angular.module('bmsApp.trugreen.schedule')
	.controller('TGPreInvoiceAllModalCtrl', function ($scope,
														 $modalInstance,
														 $q,
														 $ngBootbox,
														 TGScheduleSvc,
														 EmployeeSvc,
														 TGVisitSvc,
														 ConfigService,
														 $window,
														 params) {


		function init() {
			self.date = params.date;
			self.visits = [];
			self.employees = angular.copy(params.employees);
			angular.forEach(self.employees, function(employee) {
				angular.forEach(employee.tg_visits, function(visit) {
					if ((visit.preinvoiced) || (angular.isObject(visit.job) && visit.job.invoice_method !== 'each_visit')) {
						angular.extend(visit, {
							'disabled': true
						});
					}
					else {
						angular.extend(visit, {
							selected: true,
							disabled: false
						});
						self.selectedCount++;
					}
					self.visits.push(visit);
				});
			});
			self.loading = false;
		}

		function cancel() {
			$modalInstance.dismiss('cancel');
		}

		function onVisitClick(visit) {
			self.selectedCount = 0;
			angular.forEach(self.visits, function(visit) {
				if (visit.selected) {
					self.selectedCount++;
				}
			});
		}

		function submit() {
			var visitIds = [];
			angular.forEach(self.visits, function(visit) {
				if (visit.selected) {
					visitIds.push(visit.id);
				}
			});

			if (visitIds.length) {
				self.processing = true;
				TGScheduleSvc.preinvoiceBulk({
					visitIds: visitIds
				}).then(function(response) {
					self.processing = false;
					$modalInstance.close(response.data.preinvoiced_count);
				});
			}
		}

		var self = $scope.TGPreInvoiceAllModalCtrl = {
			loading: true,
			processing: false,
			selectedCount: 0,
			visits: [],
			methods: {
				init: init,
				cancel: cancel,
				submit: submit,
				onVisitClick: onVisitClick
			}
		};


	});
